import { Button, FormInstance, Row } from "antd";
import { useCallback } from "react";
import { ScheduleEmail } from "../../../../../../../../../components/ScheduleEmail";
import { useSelector } from "react-redux";

type FormButtonsProps = {
  form: FormInstance;
  isLoading: boolean;
  close: () => void;
  send: (values?: any) => void;
};

export const FormButtons = ({ form, isLoading, close, send }: FormButtonsProps) => {
  const onSend = useCallback((values?: any) => send(values), [send]);

  const metaData = useSelector((state: any) => state.metaData);

  return (
    <Row className="w-100 justify-end pa-4">
      <Button type="primary" shape="round" disabled={isLoading} loading={isLoading} onClick={() => onSend()}>
        Send
      </Button>
      {metaData.featureFlags.ScheduledEmails && (
        <ScheduleEmail form={form} onSchedule={onSend} disabled={isLoading} isLoading={isLoading} initialData={null} />
      )}
      <Button shape="round" className="ml-2" disabled={isLoading} onClick={close}>
        Cancel
      </Button>
    </Row>
  );
};
